<form [formGroup]="verticalPNLFilterForm" class="ledger-filter-form">
    <div class="flexbox aff-info">
      <div class="flexbox aff-info-inner" style="width: 100%;">
        <div class="flexbox ">
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="1" formControlName="start_date" id="start_date" type="date"  
              /> -->
            <ng-container *ngIf="isLocaleDateFormat">
              <input class="input-ui" searchtabindex="1" formControlName="start_date" id="date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !verticalPNLFilterForm.controls.start_date.valid}"
                 />
            </ng-container>
            <ng-container *ngIf="!isLocaleDateFormat && verticalPNLFilterForm.controls.start_date">
                <app-date-time-input
                  formControlName="start_date"
                  [dateFormat]="dateFormat"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [fieldController]="verticalPNLFilterForm.controls.start_date"
                  class="new-date-input"
                  classes="inv-date-input" 
                  tIndex="1"
                ></app-date-time-input>
            </ng-container>  
            <label for="start_date">Starting Date</label>
          </div>
          <div class="text-input-fiel">
            <!-- <input class="input-ui" searchtabindex="2" formControlName="end_date" id="end_date" type="date" 
             /> -->
            <ng-container *ngIf="isLocaleDateFormat">
              <input class="input-ui" searchtabindex="2" formControlName="end_date" id="date" type="date"
                min="{{minDate}}" max="{{maxDate}}"
                [ngClass]="{'error-box': !verticalPNLFilterForm.controls.end_date.valid}"
                 />
            </ng-container>
            <ng-container *ngIf="!isLocaleDateFormat && verticalPNLFilterForm.controls.end_date">
                <app-date-time-input
                  formControlName="end_date"
                  [dateFormat]="dateFormat"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [fieldController]="verticalPNLFilterForm.controls.end_date"
                  class="new-date-input"
                  classes="inv-date-input" 
                  tIndex="2"
                ></app-date-time-input>
            </ng-container>   
            <label for="end_date">Ending Date</label>
          </div>
        </div>
       
        <div class="flexbox mt-3">
          <div class="select-field text-input-fiel">
            <select class="input-field" searchtabindex="3" formControlName="selectedBranch" id="selectedBranch">
              <option value="">Select</option>
              <option value="">None</option>
              <option value="all">All</option>
              <option *ngFor="let item of branches" value="{{item.tenant_id}}">{{item?.branch_name ? item.branch_name : "HQ"}}
              </option>
            </select>
            <label for="selectedBranch">Branch</label>
          </div>
          <div class="text-input-fiel">
            <select class="input-ui" searchtabindex="4" formControlName="viewType" id="viewType">
              <option value="month_wise">Month Wise</option>
              <option value="consolidate">CONSOLIDATE</option>
            </select>
            <label for="viewType">View Type</label>
          </div>
        </div>

        <div class="flexbox mt-3">
        <div class="text-input-fiel">
          <select class="input-field" searchtabindex="5" formControlName="LastYearView" id="LastYearView">
            <option value="date_range">Date range</option>
            <option value="closing">CONSOLIDATE YEAR</option>
          </select>
          <label for="viewType">Last Year View</label>
        </div>
      </div>

        <div class="d-flex mt-5 justify-content-center">
          <div class="input-fiel">
            <button id="submitSearchForm" type="button" class="btn-style bg-purple mr-3" data-dismiss="modal"
              searchtabindex="3" #searchButton (keyup.enter)="clickSearchButton()"
              [disabled]="verticalPNLFilterForm.invalid"
              (click)="search(verticalPNLFilterForm.value)"> Search</button>
            <button type="button" class="btn-style bg-green" id="resetSearchForm" (click)="reset()">RESET</button>
          </div>
        </div>
      </div>
    </div>
  </form>